import router from './router'

export default {
	moduleName: 'content',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/content/index.js